/**
 * Questionary
 * @class Questionary
 */

import RangeBar from '../modules/form/range-slider.js';

export default class Questionary {

  constructor() {
    const page = document.querySelector('.questionary');
    if(!page) return;
    this.formControl();
  }

  formControl() {
    // console.log('formControl');
    new RangeBar();
  }

}
